import { ReactNode, useEffect, useState } from 'react';
import { IsoToDateAtTime, Stringable } from '../../utilities/display-utilities';
import EtaIcon from './EtaIcon';
import { useTranslation } from '@chr/online-shared-ui-localizations';
import { launchdarkly } from '../../apis/launchdarkly';

export interface EtaIconContainerProps {
  displayEta?: string;
  riskLevel?: string;
}

type TranslateType = (key: string, replaceValues?: Stringable[]) => string;

const needEtaIcon = (etaIconFlag: boolean, riskLevel: string | undefined): boolean => {
  return etaIconFlag && riskLevel === "At Risk";
}

const getEtaIcon = ( translate: TranslateType, displayEta?: string): ReactNode => {
  const etaTooltip = getEtaTooltip(translate, displayEta);
  return etaTooltip && <div style={{ marginLeft: '5px', display: 'flex' }}><EtaIcon tooltipTitle={etaTooltip} /></div>;
}

const getEtaTooltip = (translate: TranslateType, displayEta?: string,): string | null => {
  if (!displayEta) { return null; }

  return `${translate(`Estimated Arrival:`)} ${IsoToDateAtTime(displayEta, translate)}`;
};

function EtaIconContainer(props: EtaIconContainerProps) {
  const [etaIconFlag, setEtaIconFlag] = useState(false);
  const translate = useTranslation();

  useEffect(() => {
    const fetchEtaIconFlag = async() => {
      try {
        const featureFlags = await launchdarkly();
        setEtaIconFlag(featureFlags['visibility-plate-dlate-notifications']);
      }
      catch {
        console.warn('Failed to fetch feature flags')
      }
    };
    fetchEtaIconFlag();
  }, []);

  const icon = needEtaIcon(etaIconFlag, props.riskLevel) ? getEtaIcon(translate, props.displayEta) : null;
  return <>{icon}</>;
}

export default EtaIconContainer;
